import { useMutation } from "react-query";
import { geVoidedInvoiceById } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetVoidedInvoiceById = () => {
  return useMutation(geVoidedInvoiceById);
};
